import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';
import type { OverviewDays, OverviewResponse } from '../models/admin-overview.model';

/** The super-admin overview: one read-only call (cached a minute server-side). */
export const useAdminOverviewApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);
  return {
    getOverview: (days: OverviewDays, fresh = false) =>
      sendAuthGuardedRequest(ApiMethod.GET, `${routes.adminOverview}?days=${days}${fresh ? '&fresh=1' : ''}`) as Promise<OverviewResponse>,
  };
};
